
  var _styles = {
  "landmark-item": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "width": "1.62667rem",
    "height": "2.13333rem",
    "borderRadius": "0.24rem",
    "overflow": "hidden"
  },
  "landmark-item__background": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "1.62667rem",
    "height": "2.13333rem",
    "zIndex": 0
  },
  "landmark-item__content": {
    "position": "relative",
    "width": "1.62667rem",
    "height": "2.13333rem",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "zIndex": 6
  },
  "landmark-item__background-gradient": {
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "width": "1.62667rem",
    "height": "0.65333rem",
    "zIndex": 0
  },
  "landmark-item__name-wrapper": {
    "width": "1.62667rem",
    "height": "0.65333rem",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "absolute",
    "zIndex": 1,
    "bottom": 0,
    "left": 0
  },
  "landmark-item__name": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem"
  }
};



  module.exports = _styles;
  